import { useLingui } from '@lingui/react'

import type { I18nLanguage } from '@twisto/base'
import { formatNumber } from '@twisto/utils'

type FormattedNumberProps = {
  value: number | string
} & Parameters<typeof formatNumber>[1]
export const FormattedNumber = ({
  value,
  ...options
}: FormattedNumberProps) => {
  const {
    i18n: { locale },
  } = useLingui()

  return <>{formatNumber(locale as I18nLanguage, options)(value)}</>
}
